<template>
  <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.7716 1.48659L15.418 1.84015L15.7716 1.48659C16.1914 1.9064 16.1914 2.58705 15.7716 3.00687L7.19888 11.5797C6.99728 11.7813 6.72385 11.8945 6.43874 11.8945C6.15363 11.8945 5.8802 11.7813 5.67859 11.5797L1.31046 7.21153C0.890643 6.79172 0.890644 6.11107 1.31046 5.69126C1.73027 5.27144 2.41092 5.27144 2.83074 5.69125L6.43873 9.29925L14.2513 1.4866C14.6711 1.06678 15.3517 1.06678 15.7716 1.48659Z" fill="white" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'checkboxIcon'
}
</script>

<style scoped>

</style>
